import { render, staticRenderFns } from "./ItsOrderInBoundVarDetail.vue?vue&type=template&id=77c6d1d3&scoped=true&"
import script from "./ItsOrderInBoundVarDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderInBoundVarDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderInBoundVarDetail.vue?vue&type=style&index=0&id=77c6d1d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6d1d3",
  null
  
)

export default component.exports